import { render, staticRenderFns } from "./roseChart.vue?vue&type=template&id=463f522c&"
import script from "./roseChart.vue?vue&type=script&lang=ts&"
export * from "./roseChart.vue?vue&type=script&lang=ts&"
import style0 from "./roseChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports